// Generated by openapi-codegen. Do not edit manually.

import * as z from 'zod';

export const v1LinkedWorkItemResourceSchema = z.object({
  id: z.number().int().describe("Unique identifier for the linked work item"),
  title: z.coerce.string().describe("Title of the linked work item"),
  external_code: z.coerce.string().describe("Short human-readable code from the external tool (e.g. PROJ-123)").nullish(),
  url: z.coerce.string().describe("Link to the work item in the external tool (max 2048 chars)").nullish(),
  description: z.coerce.string().describe("Description of the linked work item").nullish(),
  source_name: z.coerce.string().describe("Name of the external tool the work item comes from").nullish(),
  icon_url: z.coerce.string().describe("URL of an icon representing the external tool").nullish(),
  project_id: z.number().int().describe("ID of the associated project").nullish(),
  assigned_user_id: z.number().int().describe("ID of the assigned user").nullish(),
  start_date: z.string().date().describe("Start date of the work item (ISO8601 date)").nullish(),
  due_date: z.string().date().describe("Due date of the work item (ISO8601 date)").nullish(),
  completed_at: z.string().datetime().describe("ISO8601 timestamp of when the work item was completed (null means open)").nullish(),
  external_id: z.coerce.string().describe("Customer-provided identifier for mapping with external systems (max 128 chars)").nullish(),
  created_at: z.string().datetime().describe("ISO8601 timestamp of when the work item was created").nullish(),
  updated_at: z.string().datetime().describe("ISO8601 timestamp of when the work item was last updated").nullish(),
});
